export default "__VITE_ASSET__CYChdMNb__"